/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import { Alert } from '../../../common/Alert/Alert'
import { Dropdown } from '../../../common/Dropdown/Dropdown'

const focusChange = (event) => {
    event.target.previousSibling.classList = 'active'
}

/**
 *     Form HTML
 */
const AddUserFormHTML = (props) => {

    const {
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        errorState,
        goBack,
    } = props

    const itemList = [
        {value: 'agentadmin', text: 'Agent admin'},
        {value: 'user', text: 'User'},
    ]

    let errorList: any[] = []

    if (errorState !== null) {
        if (errorState._data) {
            errorList.push(errorState._data)
        } else if (errorState.errorMessages.email) {
            errorList.push('Email has already been taken')
        }
    }

    let allFilled = ( Object.keys(props.touched).length >= 2 && Object.keys(props.errors).length === 0) ? false : true

    return(
        <div>
            {(!!Object.keys(props.errors).length && !!Object.keys(props.touched).length) && (
                Object.keys(props.errors).filter(
                    (msg) => Object.keys(props.touched).includes(msg)
                ).map((error, idx) => {
                  const msg = props.errors[error]
                  errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                })
            )}

            {(errorList.length) ? (
                <Alert type="error">
                    {errorList.map( (a, i) => (<p key={i}>{a}</p>) )}
                </Alert>
            ) : null}

            <form onSubmit={handleSubmit}>

                <h4>User details</h4>

                <div className="addUser__form__group">
                    <label>First Name</label>
                    <input
                        name="firstName"
                        id="firstName"
                        type="text"
                        placeholder="First Name"
                        className={`form-control ${errors.firstName && touched.firstName && 'is-invalid'}`}
                        onChange={handleChange}
                        onFocus={focusChange}
                        onBlur={handleBlur}
                        value={values.firstName}
                    />
                </div>

                <div className="addUser__form__group">
                    <label>Last Name</label>
                    <input
                        name="surname"
                        id="surname"
                        type="text"
                        placeholder="Last Name"
                        className={`form-control ${errors.surname && touched.surname && 'is-invalid'}`}
                        onChange={handleChange}
                        onFocus={focusChange}
                        onBlur={handleBlur}
                        value={values.surname}
                    />
                </div>

                <div className="addUser__form__group">
                    <label>Email</label>
                    <input
                        name="email"
                        id="email"
                        placeholder="Email"
                        type="text"
                        className={`form-control ${errors.email && touched.email && 'is-invalid'}`}
                        onChange={handleChange}
                        onFocus={focusChange}
                        onBlur={handleBlur}
                        value={values.email}
                    />
                </div>

                <div className="addUser__form__group">
                    <Dropdown
                        itemList={itemList}
                        name="accountType"
                        setFieldValue={setFieldValue}
                        label="User account type"
                    />

                </div>

                <div className="addUser__form__group addUser__form__group--submit">
                    <Button half={true} onClick={goBack} type="button">Cancel</Button>
                    <Button
                        half={true}
                        type="submit"
                        disabled={allFilled}
                    >
                        Add user
                    </Button>
                </div>

            </form>
        </div>
    )
}

/**
 *     Formik Validation Struture
 */
export const AddUserForm = withFormik<any, any>({

    mapPropsToValues: (props: any) => ({
        email       : '',
        firstName   : '',
        surname     : '',
        accountType : '',
    }),

    validationSchema: Yup.object().shape({
        firstName   : Yup.string().required('You need to add a first name'),
        surname     : Yup.string().required('You need to add a last name'),
        email       : Yup.string().email('Invalid email address').required('Email is required'),
        accountType : Yup.string().required('You need to add an account type'),
    }),

    handleSubmit: (values, { props, setSubmitting }) => {
        let res = { user : values }
        props.addNewUserTrigger(res)
    },

})(AddUserFormHTML)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/ManageAgency/components/AddUser.form.tsx